'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExclamationCircle = function ExclamationCircle(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: fill, d: 'M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,12c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,12,8,12z M9,9H7V4h2V9z' })
      )
    )
  );
};

ExclamationCircle.propTypes = _extends({}, _Icon2.default.propTypes);

ExclamationCircle.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  backgroundColor: 'white',
  circle: true,
  fill: _theme2.default.rawColors.pink500
});

exports.default = ExclamationCircle;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/ExclamationCircle.js
// module id = 581
// module chunks = 0